import {
  asText,
  isFilled,
  ImageField,
  NumberField,
  RichTextField,
} from '@prismicio/client';
import { Flex } from '@preventx/oxygen';
import { PrismicNextImage } from '@prismicio/next';

type DisplayImageProps = {
  image: ImageField;
  caption: RichTextField;
  widthOverride?: NumberField;
  heightOverride?: NumberField;
};

export const DisplayImage = ({
  image,
  caption,
  widthOverride,
  heightOverride,
}: DisplayImageProps) => (
  <>
    {!isFilled.richText(caption) && (
      <PrismicNextImage
        field={image}
        className="rounded-lg"
        width={widthOverride ?? undefined}
        height={heightOverride ?? undefined}
      />
    )}

    {isFilled.richText(caption) && (
      <figure className="grid justify-center">
        <Flex className="justify-center">
          <PrismicNextImage
            field={image}
            className="rounded-lg"
            width={widthOverride ?? undefined}
            height={heightOverride ?? undefined}
          />
        </Flex>

        <figcaption>{asText(caption)}</figcaption>
      </figure>
    )}
  </>
);
